import { Outlet, Link, NavLink } from "react-router-dom";
import { BookOpen, ShoppingBag, Home as HomeIcon, Instagram, Sparkles } from "lucide-react";
import { AnnouncementBar } from "./AnnouncementBar";
import { SignupPopup } from "./SignupPopup";

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <SignupPopup />
      <AnnouncementBar />
      <header className="border-b border-[#e5e5e5] bg-[#fdfbf7]/95 backdrop-blur sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" data-testid="site-logo" className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#0a192f] flex items-center justify-center">
              <BookOpen className="w-5 h-5 text-[#d4af37]" />
            </div>
            <div className="leading-tight">
              <div className="font-serif text-xl font-bold text-[#0a192f]">Faithful Store</div>
              <div className="overline text-[#4a4a4a]">Deep faith. Bold living.</div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-[#1a1a1a]">
            <NavLink data-testid="nav-home" to="/" end className={({isActive}) => isActive ? "text-[#0a192f]" : "text-[#4a4a4a] hover:text-[#0a192f]"}>Home</NavLink>
            <NavLink data-testid="nav-shop" to="/shop" className={({isActive}) => isActive ? "text-[#0a192f]" : "text-[#4a4a4a] hover:text-[#0a192f]"}>Shop</NavLink>
            <NavLink data-testid="nav-verse" to="/verse" className={({isActive}) => isActive ? "text-[#0a192f]" : "text-[#4a4a4a] hover:text-[#0a192f]"}>Daily Verse</NavLink>
            <NavLink data-testid="nav-devotionals" to="/devotionals" className={({isActive}) => isActive ? "text-[#0a192f]" : "text-[#4a4a4a] hover:text-[#0a192f]"}>Devotionals</NavLink>
            <NavLink data-testid="nav-library" to="/library" className={({isActive}) => isActive ? "text-[#0a192f]" : "text-[#4a4a4a] hover:text-[#0a192f]"}>My Library</NavLink>
            <a data-testid="nav-about" href="#about" className="text-[#4a4a4a] hover:text-[#0a192f]">Our Heart</a>
          </nav>
          <Link to="/shop" data-testid="header-cta" className="btn-navy inline-flex items-center gap-2 text-sm">
            <ShoppingBag className="w-4 h-4" /> Browse Store
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-[#e5e5e5] bg-[#0a192f] text-white mt-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#d4af37] flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-[#0a192f]" />
              </div>
              <div className="font-serif text-2xl">Faithful Store</div>
            </div>
            <p className="mt-4 text-sm text-white/70 max-w-md leading-relaxed">
              A Christian lifestyle bookstore for those who seek deeper study, guidance, and inspiration
              for the real struggles of daily life.
            </p>
          </div>
          <div>
            <div className="overline text-[#d4af37]">Explore</div>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li><Link to="/shop" className="hover:text-[#d4af37]">All Products</Link></li>
              <li><Link to="/shop?cat=ebook" className="hover:text-[#d4af37]">Ebooks</Link></li>
              <li><Link to="/shop?cat=journal" className="hover:text-[#d4af37]">Journals</Link></li>
              <li><Link to="/shop?cat=sticker" className="hover:text-[#d4af37]">Stickers</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#d4af37]">Connect</div>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2"><Instagram className="w-4 h-4" /> Instagram</li>
              <li className="flex items-center gap-2"><Sparkles className="w-4 h-4" /> Pinterest</li>
              <li><Link data-testid="footer-admin" to="/admin/login" className="hover:text-[#d4af37]">Owner Login</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
          © {new Date().getFullYear()} Faithful Store. Made with faith & purpose.
        </div>
      </footer>
    </div>
  );
}
